import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './configureStore';
import './index.css';
import App from './react/App';
// import registerServiceWorker from './registerServiceWorker';


// ReactDOM.render(<App/>, document.getElementById('root'));
import { initWxJSSDK } from './util/wxUtil';

console.log('NODE_ENV', process.env.NODE_ENV);
console.log('REACT_APP_RELEASE_ENV', process.env.REACT_APP_RELEASE_ENV);

// initIOSUrl();
initWxJSSDK(); //必须第一时间初始化

const store = configureStore();
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,

    document.getElementById('root')
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js